import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${API_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  // Levels
  getLevels: async () => {
    const response = await axios.get(`${API}/levels`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  getLevel: async (levelNumber) => {
    const response = await axios.get(`${API}/levels/${levelNumber}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Progress
  recordPractice: async () => {
    const response = await axios.post(`${API}/progress/practice`, {}, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  completeLevel: async (levelNumber) => {
    const response = await axios.post(`${API}/progress/complete-level/${levelNumber}`, {}, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Blog
  getBlogPosts: async () => {
    const response = await axios.get(`${API}/blog`);
    return response.data;
  },

  getBlogPost: async (postId) => {
    const response = await axios.get(`${API}/blog/${postId}`);
    return response.data;
  },

  // Books
  getBooks: async () => {
    const response = await axios.get(`${API}/books`);
    return response.data;
  },

  getBook: async (bookId) => {
    const response = await axios.get(`${API}/books/${bookId}`);
    return response.data;
  },

  // Comments
  createComment: async (postId, content) => {
    const response = await axios.post(`${API}/comments`, 
      { post_id: postId, content },
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  getComments: async (postId) => {
    const response = await axios.get(`${API}/comments/${postId}`);
    return response.data;
  }
};